import React from 'react'
import styles from './Hero.scss'
import PropTypes from 'prop-types'

export default function Hero({ children }) {
  return <div className={styles.Hero}>{children}</div>
}

Hero.propTypes = {
  children: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/components/Hero/index.js